import React, { useState, useRef } from 'react';

import Modal from 'react-bootstrap/Modal';
import { FaEdit } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { toast } from 'react-toastify';
import { format, subYears, addDays, isValid } from 'date-fns';
import Bunexe_service from '../../../Bunexe_service';

const EditEni = ({ infoEleve, myheader, reload_List }) => {
  const nomref = useRef();
  const [show, setShow] = useState(false);
  const [moyns1, setMoyns1] = useState(infoEleve.moy);
  const [section, setSection] = useState(infoEleve.section);
  let url_ = Bunexe_service.url;
  //'http://localhost:8086';
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const submitform = (e) => {
    e.preventDefault();

    //console.log(`username ${username} et password:${password}`);
    let mydata = {
      section: section,
    };
    const requestOptions = {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mydata),
    };
    try {
      fetch(url_ + `/eni/edit_eleve/${infoEleve.id}`, requestOptions)
        .then((response) => {
          return response.json();
          //else throw Error(response.statusText);
        })
        .then((data) => {
          if (data.hasError) {
            toast.error(data.message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            //afficherMessage(data.message);
          } else {
            //  listeEleves_func(Ecole);

            reload_List();
            setShow(false);
          }
          // console.log(data);
        })
        .catch((err) => {
          console.error(err);
        });
    } catch (error) {
      console.error("Erreur d'insertion ...", error);
    }
  };

  return (
    <>
      {/* <Button variant='primary' onClick={handleShow}>
        edit
      </Button> */}
      <FaEdit onClick={handleShow} />

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title>Modification Ecole Normale Instituteur</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='container mx-auto'>
            <div className='row'>
              <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 border rounded py-2'>
                <h2 className='text-center'>{myheader.LibelleEt}</h2>
                <h4 className='text-center'>{myheader.AdresseEt}</h4>
                <h6 className='text-center'>{myheader.Ecole}</h6>
                <hr />
                <h6>
                  Identifiant :
                  <span className='font-weight-bold font-italic'>
                    {infoEleve.IDENTIFIANT}
                  </span>
                </h6>
                <h6>
                  <span>Nom :</span>
                  <span className='ml-1 font-weight-bold font-italic'>
                    {infoEleve.NOMEL}
                  </span>
                  <span className='ml-5'>Prenom :</span>
                  <span className='ml-1 font-weight-bold font-italic'>
                    {infoEleve.PRENOMEL}
                  </span>
                </h6>
                <h6>Sexe :{infoEleve.SEXE == '1' ? 'M' : 'F'}</h6>
                <h6>
                  Date Naissance :
                  <span className='ml-1 font-weight-bold font-italic'>
                    {format(
                      addDays(new Date(infoEleve.DNAISS.substr(0, 10)), 1),
                      'dd/MM/yyyy'
                    )}
                  </span>
                </h6>
                <hr />
                <Form autoComplete='off' noValidate onSubmit={submitform}>
                  <Form.Row>
                    <Form.Group as={Col} controlId='formGridSection'>
                      <Form.Label>Section</Form.Label>
                      <Form.Control
                        as='select'
                        value={section}
                        onChange={(e) => {
                          setSection(e.target.value);
                        }}
                      >
                        <option>Prescolaire</option>
                        <option>Fondamentale</option>
                      </Form.Control>
                    </Form.Group>
                  </Form.Row>
                </Form>
                <hr />
                {/* {message && message.length > 0 && <small>{message}</small>} */}
              </div>
            </div>
          </div>
          {/* Woohoo, you're reading this text in a modal! */}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Fermer
          </Button>
          <Button variant='primary' onClick={submitform}>
            Modifier
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditEni;
